<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#grasimi2plus">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Grăsimi, din care</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">18.9 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">2.8 g</span></div>

    </div>

    <div id="grasimi2plus" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grasi saturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">2.1 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.31 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grași polinesaturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue"></span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue"></span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid docosahexaenoic (DHA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.07 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0097 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">OMEGA 6 Acid linoleic LA</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">7.6 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.119 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">OMEGA 3 Acid alfa-linolenic ALA</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.62 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0906 g</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "grasimi",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>
.active-grasimi {
  background: #F8F8F8;
}
</style>
